import App from '../index.js';
import { isEmpty, forEach, uniq } from 'lodash';

App.BotsForm = (function () {
    let botTemplate = $('<div class="bot-item"></div>').html($('#bot_item_template').find('.bot-item:last-child').html());
    const questionTemplate = $('<div class="question-item align-items-center"></div>').html($('#bot_item_template .question-list .question-item:last-child').html());
    let touched = false;

    function addNewCategory () {
        const template = botTemplate.clone();
        const elBotBody = $('.bot-body');
        const updatedCurrentCounter = parseInt(elBotBody.find('.bot-item:last-child').data('counter') || 0) + 1;

        template.find('.category-field, .answer-field, .question-field').val('');
        template.find('.question-item:not(:last-child)').remove();

        template.attr('data-counter', updatedCurrentCounter).data('counter', updatedCurrentCounter);
        template.find('.ai-summarize-search-result-type-field').attr('name', 'items[' + updatedCurrentCounter + '][ai_summarize_search_result_type]');
        template.find('.ai-summarize-search-question-type-field').attr('name', 'items[' + updatedCurrentCounter + '][search_question_type]');
        template.find('.ai-summarize-group .form-check').each(function ( index, item ) {
            $(this).find('.ai-summarize-search-question-type-field').attr('id', 'search_question_type_' + index + '_' + updatedCurrentCounter);
            $(this).find('.ai-summarize-search-question-type-label').attr('for', 'search_question_type_' + index + '_' + updatedCurrentCounter);

            $(this).find('.ai-summarize-search-result-type-field').attr('id', 'ai_summarize_search_result_type_' + index + '_' + updatedCurrentCounter);
            $(this).find('.ai-summarize-search-result-type-label').attr('for', 'ai_summarize_search_result_type_' + index + '_' + updatedCurrentCounter);
        });

        elBotBody.append(template);
        buildWysiwygEditor();
    }

    function prepareDataToSend ( e ) {
        e.preventDefault();
        touched = false;
        window.onbeforeunload = null;

        const elForm = $(this);

        elForm.find('.bot-body .bot-item').each(function ( botItemIndex, event ) {
            let elBotItem = $(this);

            elBotItem.find('.id-field').attr('name', `items[${ botItemIndex }][id]`);

            elBotItem.find('.enabled-field').attr('name', `items[${ botItemIndex }][enabled]`);
            elBotItem.find('.category-field').attr('name', `items[${ botItemIndex }][category]`);
            elBotItem.find('.answer-field').attr('name', `items[${ botItemIndex }][answer]`);
            elBotItem.find('.enable-send-user-question-to-ai-field').attr('name', `items[${ botItemIndex }][enable_send_user_question_to_ai]`);
            elBotItem.find('.ai-summarize-search-result-type-field').attr('name', `items[${ botItemIndex }][ai_summarize_search_result_type]`)
            elBotItem.find('.ai-summarize-search-question-type-field').attr('name', `items[${ botItemIndex }][search_question_type]`);
            elBotItem.find('.question-item').each(function ( questionItemIndex, event ) {
                let elQuestionItemID = $(this).find('.question-id-field'),
                    elQuestionItem = $(this).find('.question-field');

                if (!isEmpty(elQuestionItem.val())) {
                    elQuestionItemID.attr('name', `items[${ botItemIndex }][questions][${ questionItemIndex }][id]`);
                    elQuestionItem.attr('name', `items[${ botItemIndex }][questions][${ questionItemIndex }][text]`);
                }
            });

            if($(this).is(':last-child')) {
                elBotItem.find('.id-field, .category-field, .answer-field, .question-item .question-id-field, .question-item .question-field').removeAttr('name');
            }
        });

        elForm[0].submit();
    }

    function preventPageLoad () {
        if (!touched) {
            window.onbeforeunload = function () {
                return touched ? "You haven't save your changes! are you sure you want to leave?" : false;
            }
            touched = true;
        }
    }

    function uploadCsvData () {
        const formFile = this;
        if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
            console.log('The File APIs are not fully supported in this browser.');
            return;
        }

        if (!formFile.files) {
            console.error("This browser doesn't seem to support the `files` property of file inputs.");
        } else if (formFile.files[0]) {
            const fileName = $(this).val();

            if (!isCSVFile(fileName)) {
                $(this).val('');
                alert('Please select correct file format');
                return;
            }
            $('#bot_data .bot-body .bot-item:last-child').remove();
            const elBotList = $('.bot-list');

            elBotList.addClass('loading');

            setTimeout(() => {
                let file = formFile.files[0];
                let fr = new FileReader();
                receivedText = () => {
                    const jsonResult = $.csv.toObjects(fr.result);
                    updateFormFromCSV(jsonResult);
                    elBotList.removeClass('loading');
                }

                fr.onload = receivedText;
                fr.readAsText(file);
            }, 500);

        }
    }


    function isCSVFile ( fileName ) {
        var regex = new RegExp("(.*?)\.(csv)$");
        return regex.test(fileName.toLowerCase());
    }

    function updateFormFromCSV ( json )
    {
        if (!isEmpty(json)) {
            forEach(json, ( item, index ) => {
                const currentBotTemplate = $('<div/>').html(botTemplate.clone());

                if (!isEmpty(item.Question)) {
                    let questions = uniq(item.Question.split(/\n/));
                    const questionListTemplate = [];

                    forEach(questions, function ( question, question_index ) {
                        if (!$('.question-field[value="' + CSS.escape(question) + '"]')[0]) {
                            const currentQuestionTemplate = $('<div/>').html(questionTemplate.clone());
                            currentQuestionTemplate.find('.question-field').attr('value', question);
                            questionListTemplate.push(currentQuestionTemplate.html())
                        }
                    });

                    currentBotTemplate.find('.question-list').html(questionListTemplate.join(' '));
                }

                if (!isEmpty(currentBotTemplate.find('.question-list .question-item:first-child .question-field').val())) {
                    currentBotTemplate.find('.category-field').attr('value', item.Category);
                    currentBotTemplate.find('.answer-field').html($('<div/>').html(item.Answer).text().linkify());
                    $('#bot_data .bot-body').append(currentBotTemplate.html());
                }
            });
        }

        addNewCategory();
        buildWysiwygEditor();
        $('#upload_data').val('');
    }

    function buildWysiwygEditor () {
        App.wysiwygEditor('.bot-body .bot-item .answer-field:not(.mce-active)', 100, function (el,  data ) {
            if (el.closest('.bot-item').is(':last-child')) {
                addNewCategory();
            }

            preventPageLoad();
        }, null, 'numlist bullist');
    }

    function onChangeAiSummaryResult () {
        let elParent = $(this).closest('.ai-summarize-group'),
            value = $(this).val();

        elParent.find('.ai-summary-option').toggleClass('d-none', value !== 'ai_summary');
    }

    return {
        init: function () {
            buildWysiwygEditor();

            $('body')
                .on('input', '.answer-field, .question-field, .category-field', function () {
                    const el = $(this);

                    if (el.closest('.bot-item').is(':last-child')) {
                        addNewCategory();
                    }
                    preventPageLoad();
                })
                .on('input', '[name="name"]', preventPageLoad)
                .on('change', '.question-field', function () {
                    $(this).attr('value', $(this).val());
                })
                .on('click', '#add_category', addNewCategory)
                .on('click', '.bot-item .delete-bot-item', function () {
                    $(this).closest('.bot-item').remove();
                    preventPageLoad();
                })
                .on('click', '.bot-item-question .add-question-item', function ( e ) {
                    e.preventDefault();
                    questionTemplate.find('.question-field').attr('placeholder', 'Question').val('');
                    questionTemplate.find('.question-id-field').attr('placeholder', 'Question').val('');
                    $(this).closest('.bot-item-question').find('.question-list').append(questionTemplate.clone());
                    preventPageLoad();
                })
                .on('click', '.bot-item-question .delete-question-item .btn-delete', function ( e ) {
                    e.preventDefault();
                    $(this).closest('.question-item').remove();
                    preventPageLoad();
                }).on('change', '#upload_data', uploadCsvData)
                .on('change', '.ai-summarize-group .ai-summarize-search-result-type-field', onChangeAiSummaryResult);

            $('#bot_form').on('submit', prepareDataToSend);
        }
    };

})();

// Provide the route name
App.registerRoute('global-bots.edit', App.BotsForm.init);
App.registerRoute('global-bots.create', App.BotsForm.init);

export default App.BotsForm;
